import { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';
import { BackButton } from './BackButton';

/**
 * The sticky bar at the top of every page on a phone (Layout renders it):
 * the menu button on the left, and the page's own title, right-aligned.
 *
 * The bar belongs to Layout but the title belongs to the page, so Layout
 * hands down the bar's empty slot and a page's PhoneTitle renders into it.
 * PageHeader does this for every list page; a record page (a job, an item)
 * passes onBack too, and its back button sits beside the menu button.
 */
export const PhoneHeaderSlot = createContext(null);

/** Bar height: PhonePanel's sticky tabs stick just below it. */
export const PHONE_HEADER_HEIGHT = 64;

export function PhoneTitle({ title, subtitle, onBack, backLabel = 'Back' }) {
  const slot = useContext(PhoneHeaderSlot);
  if (!slot) return null;
  return createPortal(
    <>
      {onBack && <BackButton onClick={onBack} label={backLabel} />}
      {/* A section's title at page-title weight; a record's (a job's name,
          beside the back button) a size down, so most names fit the line.
          A subtitle (a job's client) sits under it, right-aligned too */}
      <div className="ml-auto min-w-0 text-right">
        <h1
          className={`truncate leading-tight font-normal tracking-[-0.01em] ${onBack ? 'text-xl' : 'text-[28px]'}`}
          data-testid="phone-title"
        >
          {title}
        </h1>
        {subtitle && <p className="truncate text-sm text-muted-foreground leading-tight" data-testid="phone-subtitle">{subtitle}</p>}
      </div>
    </>,
    slot
  );
}
